// Mirrors server/utils/normalizeTags.js — some scraped sponsor docs have a
// single tags[] entry that's actually several tags joined by a comma (e.g.
// "AI,Software") instead of separate array elements. Splitting on read
// means filtering/matching against a single clean tag (e.g. "AI") actually
// finds these entries instead of silently missing them.
export const normalizeTags = (tags?: (string | null | undefined)[] | null): string[] => {
    if (!Array.isArray(tags)) return [];
    const out = new Set<string>();
    tags.forEach((raw) => {
        if (!raw) return;
        String(raw).split(',').forEach((part) => {
            const t = part.trim();
            if (t) out.add(t);
        });
    });
    return Array.from(out);
};
